import { render, staticRenderFns } from "./facebookUser.vue?vue&type=template&id=591b43b4&scoped=true&"
import script from "./facebookUser.vue?vue&type=script&lang=js&"
export * from "./facebookUser.vue?vue&type=script&lang=js&"
import style0 from "./facebookUser.vue?vue&type=style&index=0&id=591b43b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b43b4",
  null
  
)

export default component.exports